import React from 'react'
import { useController } from 'react-hook-form'
import * as S from './style'

export const Field = ({
  labelText,
  name,
  control,
  onChangeInput,
  inputTextColor = '#000',
  ...restProps
}) => {
  const {
    field: { value, onChange, onBlur, ref },
    fieldState: { error }
  } = useController({ name, control })

  return (
    <S.Wrapper>
      <S.Label htmlFor={name}>{labelText}</S.Label>
      <S.Input
        id={name}
        title={name}
        textColor={inputTextColor}
        onChange={(e) =>
          onChangeInput ? onChange(onChangeInput(e)) : onChange(e)
        }
        onBlur={onBlur}
        value={value || ''}
        error={error}
        ref={ref}
        {...restProps}
      />
      {error && <S.Error>{processError(error).message}</S.Error>}
    </S.Wrapper>
  )
}

const processError = (error) => {
  if (error.type === 'typeError') {
    return { ...error, message: 'Caracter inesperado e inválido!' }
  }
  return error
}
